module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lee-overview lee-panel"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('span', {
    staticClass: "role"
  }, [_vm._v(_vm._s(_vm.user.role))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.user.photo,
      "width": "100",
      "height": "100"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.profile), function(info) {
    return _c('div', {
      key: info.id,
      staticClass: "list-item"
    }, [_c('i', {
      class: info.icon,
      staticStyle: {
        "width": "10%"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(info.key))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(info.value))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83a0f14a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user_overview.vue
// module id = 607
// module chunks = 1